export const USER_LOGIN = 'USER_LOGIN'
export const USER_DETAILS_UPDATE = 'USER_DETAILS_UPDATE'
export const USER_RESET = 'USER_RESET'

export const APP_USER_CATEGORY = {
  PERSONAL_ACCOUNT: 1, //tai khoan ca nhan - mac dinh
  COMPANY_ACCOUNT: 2 //tai khoan doanh nghiep
}
